import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { DialogProps } from "@saleor/types";
import classNames from "classnames";
import React from "react";

const useStyles = makeStyles(
  {
    buttonConfirm: {
      backgroundColor: "#FFD15C !important",
      marginLeft: "8px"
    },
    buttonDisabled: {
      backgroundColor: "#A1A1A1 !important"
    },
    contentText: {
      fontSize: "17px",
      fontWeight: 400
    },
    dialogContent: {
      display: "flex",
      flexDirection: "row",
      width: "100%"
    },
    textField: {
      marginTop: "20px",
      width: "100%"
    }
  },
  {
    name: "GrabExpressOverrideDialog"
  }
);

interface GrabExpressOverrideDialogProps extends DialogProps {
  onSubmitOverride?: (reason) => void;
}

const GrabExpressOverrideDialog: React.FC<GrabExpressOverrideDialogProps> = props => {
  const { onClose, open, onSubmitOverride } = props;
  const classes = useStyles(props);

  const [reason, setReason] = React.useState("");

  function handleClose() {
    onClose();
    setReason("");
  }

  return (
    <Dialog onClose={handleClose} open={open} maxWidth="xs" fullWidth>
      <>
        <DialogTitle>Reason for override</DialogTitle>
        <DialogContent>
          <div className={classes.dialogContent}></div>
          <TextField
            id="overrideTxt"
            label="Reason for Override"
            className={classes.textField}
            multiline
            rows={6}
            value={reason}
            onChange={e => setReason(e.target.value)}
          ></TextField>
        </DialogContent>
        <DialogActions>
          <div>
            <Button
              id="overrideCancelBtn"
              autoFocus
              onClick={handleClose}
              color="secondary"
            >
              Cancel
            </Button>
            <Button
              id="overrideSubmitBtn"
              autoFocus
              disabled={reason ? false : true}
              onClick={() => {
                onSubmitOverride(reason);
                handleClose();
              }}
              color="primary"
              variant="contained"
              className={classNames({
                [classes.buttonConfirm]: reason,
                [classes.buttonDisabled]: !reason
              })}
            >
              Submit
            </Button>
          </div>
        </DialogActions>
      </>
    </Dialog>
  );
};

export default GrabExpressOverrideDialog;
